// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { getCurrentAdminFeefirst, getUserById } from "../api/api";
// import "../PaymentScreen/PaymentScreen.css";
// import bgImage from "../../assets/images/brown-background.jpg";
// import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";

// const PaymentScreen = () => {
//   const [loading, setLoading] = useState(false);
//   const [paymentDetails, setPaymentDetails] = useState(null);
//   const navigate = useNavigate();

//   const fetchPaymentDetails = useCallback(async () => {
//     setLoading(true);
//     try {
//       const userData = localStorage.getItem("currentUser");
//       const parsedUserData = JSON.parse(userData);
//       const _id = parsedUserData?.id || parsedUserData?._id;
//       const values = { user_id: _id };

//       const response = await getCurrentAdminFeefirst(values);
//       setPaymentDetails(response);
//     } catch (error) {
//       console.error("Error fetching admin fee:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchPaymentDetails();
//     getUser();
//   }, [fetchPaymentDetails]);

//   const getUser = async () => {
//     const storedUser = localStorage.getItem("currentUser");
//     const parsedUser = JSON.parse(storedUser);
//     const _id = parsedUser?.id || parsedUser?._id;
//     console.log("Idddd222", _id);
//     try {
//       const res = await getUserById({ user_id: _id });
//       console.log("getUserById_payment", JSON.stringify(res));
//       console.log(
//         "user_data_page",
//         JSON.stringify(res?.data?.profile_completion_status)
//       );
//       if (res?.data?.profile_completion_status === "gender") {
//         return navigate("/gender");
//       }
//     } catch (err) {
//       console.error("Error in getUserById:", err);
//     }
//   };

//   const handleOpenInAppBrowser = () => {
//     const userData = localStorage.getItem("currentUser");
//     const parsedUserData = JSON.parse(userData);
//     const _id = parsedUserData?.id || parsedUserData?._id;
//     const adminId =
//       paymentDetails?.adminfee?.id || paymentDetails?.adminfee?._id;
//     const url = `https://backend.connecttovow.com/kfdsgkhdksfhskufhdkfjhkugh4778vbkjhdvsjhdvjkshgdvwukdvbkjhb/${adminId}/${_id}`;

//     navigate("/PaymentWebView", { state: { paymentUrl: url } });
//   };

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <div className="spinner"></div>
//       </div>
//     );
//   }

//   return (
//     <div
//       className="payment-container sechdr-toppding"
//       style={{
//         backgroundImage: `url(${bgImage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//       }}
//     >
//       <div className="containerall">
//         <RegistraionFlowHeader />
//         {/* <RegistraionFlowHeader /> */}
//         <div className="paymentSmallContainer">
//           <div className="amount-container">
//             <h2 className="paymentregistration-title">Admin Fee</h2>
//             <p className="paymentregistration-description">
//               Complete your registration by paying this one-time admin fee to
//               activate your account.
//             </p>
//             <p className="paymentamount-label">Total Amount</p>
//             <p className="paymentamount">
//               {paymentDetails?.adminfee
//                 ? `${paymentDetails?.adminfee?.currency_symbol} ${paymentDetails?.adminfee?.price}`
//                 : "Loading..."}
//             </p>
//           </div>

//           <button className="pay-button" onClick={handleOpenInAppBrowser}>
//             Pay Now
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentScreen;

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  getCurrentAdminFeefirst,
  getUserById,
  GetStripeData,
  completeZeroAdminFee,
} from "../api/api";
import "../PaymentScreen/PaymentScreen.css";
import bgImage from "../../assets/images/brown-background.jpg";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { environment } from "../../environments/environments";
import Swal from "sweetalert2";
import {
  buildZeroFeeCompletionPayload,
  formatAdminFeeDisplay,
  isExactZeroFee,
} from "./zeroAdminFee";

const stripePromise = loadStripe(environment?.stripe_id);

const actionButtonStyle = {
  marginTop: 20,
  backgroundColor: environment?.Coral_Red,
  width: "100%",
  color: "#fff",
  padding: "10px",
  border: "none",
  borderRadius: "6px",
  fontSize: "16px",
  cursor: "pointer",
};

const PaymentScreen = () => {
  const [loading, setLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const [uservalue, setUservalue] = useState(null);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [zeroFeeSubmitting, setZeroFeeSubmitting] = useState(false);

  const navigate = useNavigate();
  const isZeroFee = isExactZeroFee(paymentDetails?.adminfee?.price);

  // Step 1: Fetch admin fee + user info
  const fetchPaymentDetails = useCallback(async () => {
    setLoading(true);
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const _id = parsedUserData?.id || parsedUserData?._id;
      const response = await getCurrentAdminFeefirst({ user_id: _id });
      setPaymentDetails(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchUser = useCallback(async () => {
    try {
      const storedUser = localStorage.getItem("currentUser");
      const parsedUser = JSON.parse(storedUser);
      const _id = parsedUser?.id || parsedUser?._id;
      const res = await getUserById({ user_id: _id });
      setUservalue(res?.data);
      if (res?.data?.profile_completion_status === "gender")
        navigate("/gender");
    } catch (err) {
      console.error(err);
    }
  }, [navigate]);

  useEffect(() => {
    fetchPaymentDetails();
    fetchUser();
  }, [fetchPaymentDetails, fetchUser]);

  // Paid path: create Stripe PaymentIntent (unchanged for non-zero fees)
  const handleDetails = async () => {
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const _id = parsedUserData?.id || parsedUserData?._id;

      const value = {
        id: _id,
        name: parsedUserData.name,
        email: parsedUserData.email,
        amount: paymentDetails?.adminfee?.price,
        currency: paymentDetails?.adminfee?.currency,
        stripe_id: parsedUserData.stripe_customer_id || "",
        product_id: paymentDetails?.adminfee?.id,
        type: "oneoff",
      };

      const stripeData = await GetStripeData(value);
      setClientSecret(stripeData?.paymentIntent?.client_secret);
      setShowPaymentForm(true);
    } catch (error) {
      console.error(error);
    }
  };

  // Zero-fee path: complete via backend without Stripe
  const handleZeroFeeContinue = async () => {
    if (zeroFeeSubmitting) {
      return;
    }

    setZeroFeeSubmitting(true);
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const jwtToken = localStorage.getItem("jwtToken");
      const payload = buildZeroFeeCompletionPayload(parsedUserData, jwtToken);

      if (!payload) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "We could not verify your session. Please sign in again and retry.",
          confirmButtonText: "OK",
        });
        return;
      }

      const response = await completeZeroAdminFee(payload);

      if (response?.success) {
        navigate("/gender");
        return;
      }

      if (response) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text:
            response?.message ||
            "Unable to continue with zero Admin Fee registration. Please try again.",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setZeroFeeSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div
      className="payment-container sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="paymentSmallContainer">
          <div className="amount-container">
            <h2 className="paymentregistration-title">Admin Fee</h2>
            <p className="paymentregistration-description">
              {isZeroFee
                ? "No Admin Fee is due for your account. Continue to complete registration."
                : "Complete your registration by paying this one-time admin fee to activate your account."}
            </p>
            <p className="paymentamount-label">Total Amount</p>
            <p className="paymentamount">
              {formatAdminFeeDisplay(paymentDetails?.adminfee)}
            </p>

            {!showPaymentForm && (
              <button
                type="button"
                onClick={isZeroFee ? handleZeroFeeContinue : handleDetails}
                disabled={isZeroFee && zeroFeeSubmitting}
                style={{
                  ...actionButtonStyle,
                  cursor:
                    isZeroFee && zeroFeeSubmitting ? "not-allowed" : "pointer",
                  opacity: isZeroFee && zeroFeeSubmitting ? 0.7 : 1,
                }}
              >
                {isZeroFee
                  ? zeroFeeSubmitting
                    ? "Continuing..."
                    : "Continue"
                  : "Pay Now"}
              </button>
            )}
          </div>

          {/* Stripe form only for paid (non-zero) Admin Fee after Pay Now */}
          {!isZeroFee && showPaymentForm && clientSecret && (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <CheckoutForm clientSecret={clientSecret} user={uservalue} />
            </Elements>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentScreen;
